
<template>
  <v-row>
    <v-col cols="12">
      <base-card>
        <v-card-title>Edit Distribution Package "{{ distribPackage.name }}"</v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              cols="12"
              sm="12"
              class="pb-0"
            >
              <v-text-field
                v-model.trim="patched.name"
                label="Name*"
                :counter="255"
                :rules="rules.nameRules"
                required
                dense
                outlined
              />
              <v-text-field
                v-model.trim="patched.mtPrefix"
                label="MT URL prefix"
                dense
                prepend-inner-icon="mdi-link"
                outlined
                filled
              />
              <v-text-field
                v-model.trim="patched.mtPrerollPrefix"
                label="MT pre-roll URL prefix"
                prepend-inner-icon="mdi-link"
                dense
                outlined
                filled
              />
            </v-col>
            <v-col
              cols="12"
              md="12"
              class="pb-0 pt-0"
            >
              <v-radio-group
                v-model="patched.format"
                row
                dense
                class="ma-0"
                @change="changeFormat"
              >
                <span class="text-subtitle-1 mr-2">Format:</span>
                <v-radio
                  label="MediaTailor"
                  value="mediatailor"
                />
                <v-radio
                  label="Broadpeak"
                  value="broadpeak"
                />
              </v-radio-group>
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="pt-0"
            >
              <v-row align="center">
                <v-checkbox
                  v-model="includeVideoPlayerWidth"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="videoPlayerWidthKey"
                  :items="['ads.w', 'width']"
                  label="Video player width"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="videoPlayerWidth"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeVideoPlayerHeight"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="videoPlayerHeightKey"
                  :items="['ads.h', 'height']"
                  label="Video player height"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="videoPlayerHeight"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeDeviceID"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="deviceIDKey"
                  :items="['ads.did', 'did']"
                  label="Device ID"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="deviceID"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeAppBundle"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="appBundleKey"
                  :items="['ads.app_bundle', 'app_bundle']"
                  label="App Bundle"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="appBundle"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                  hint="com.(NP appname).(NP appbundle)"
                  persistent-hint
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeAppName"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="appNameKey"
                  :items="['ads.app_name', 'app_name']"
                  label="App Name"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="appName"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                  placeholder="project name, ie HeroGo"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeNameOfTVChannel"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="nameOfTVChannelKey"
                  :items="['ads.channel_name', 'channel_name']"
                  label="Name of TV channel"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="nameOfTVChannel"
                  disabled
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                  placeholder="project name, ie HeroGo"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeGenre"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="genreKey"
                  :items="['ads.content_genre', 'content_genre']"
                  label="Genre"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="genre"
                  disabled
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeRating"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="ratingKey"
                  :items="['ads.rating', 'rating']"
                  label="Rating"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="rating"
                  disabled
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeNameOfTheContentSeries"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="nameOfTheContentSeriesKey"
                  :items="['ads.content_series', 'content_series']"
                  label="Name of the content series"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="nameOfTheContentSeries"
                  disabled
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeUsPrivacy"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="usPrivacyKey"
                  :items="['ads.us_privacy', 'us_privacy']"
                  label="CCPA US Privacy String"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="usPrivacy"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeAppStoreURL"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="appStoreURLKey"
                  :items="['ads.app_store_url', 'app_store_url']"
                  label="App Store URL (CTV)"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="appStoreURL"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeProvider"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="providerKey"
                  :items="['ads.provider', 'provider']"
                  label="Provider Name"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="provider"
                  disabled
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeChain"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="chainKey"
                  :items="['ads.schain', 'schain']"
                  label="OpenRTB SupplyChain object"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="chain"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeIABCategoryID"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="IABCategoryIDKey"
                  :items="['ads.ic', 'ic']"
                  label="IAB Category ID (for the App)"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="IABCategoryID"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeContentCat"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="contentCatKey"
                  :items="['ads.content_cat', 'content_cat']"
                  label="IAB Category (for the Content)"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="contentCat"
                  disabled
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeContentEpisode"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="contentEpisodeKey"
                  :items="['ads.content_episode', 'content_episode']"
                  label="Content Episode"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="contentEpisode"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                  hint=""
                  persistent-hint
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeContentTitle"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="contentTitleKey"
                  :items="['ads.content_title', 'content_title']"
                  label="Content Title"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="contentTitle"
                  disabled
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                  hint=""
                  persistent-hint
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeContentSeason"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="contentSeasonKey"
                  :items="['ads.content_season', 'content_season']"
                  label="Content Season"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="contentSeason"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                  hint=""
                  persistent-hint
                />
              </v-row>
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="pt-0"
            >
              <v-row align="center">
                <v-checkbox
                  v-model="includeURLFromWebsitesOnly"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="URLFromWebsitesOnlyKey"
                  :items="['ads.url', 'url']"
                  label="URL (from websites only)"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="URLFromWebsitesOnly"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeGDPRConsent"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="GDPRConsentKey"
                  :items="['ads.gdpr_consent', 'gdpr_consent']"
                  label="GDPR Consent"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="GDPRConsent"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeGDPR"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="GDPRKey"
                  :items="['ads.gdpr', 'gdpr']"
                  label="GDPR"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="GDPR"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeIP"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="IPKey"
                  :items="['ads.ip', 'ip']"
                  label="IP Address"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="IP"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeUA"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="UAKey"
                  :items="['ads.ua', 'ua']"
                  label="User Agent"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="UA"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includePodMaxDur"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="podMaxDurKey"
                  :items="['ads.pod_max_dur', 'pod_max_dur']"
                  label="Maximum ad pod duration"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="podMaxDur"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeCb"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="cbKey"
                  :items="['ads.cb', 'cb']"
                  label="Cache buster"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="cb"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-divider class="" />
              <v-row align="center">
                <v-checkbox
                  v-model="includeCustom1"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-text-field
                  v-model="custom1Key"
                  label="Custom 1"
                  class="shrink mr-2 mt-0"
                  append-outer-icon="mdi-equal"
                />
                <v-text-field
                  v-model="custom1"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeCustom2"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-text-field
                  v-model="custom2Key"
                  label="Custom 2"
                  class="shrink mr-2 mt-0"
                  append-outer-icon="mdi-equal"
                />
                <v-text-field
                  v-model="custom2"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-divider class="" />
              <v-row align="center">
                <v-checkbox
                  v-model="includeAppPlatform"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="appPlatformKey"
                  :items="['ads.app_platform', 'app_platform']"
                  label="App Platform"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="appPlatform"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                  hint=""
                  persistent-hint
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeAppVer"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="appVerKey"
                  :items="['ads.app_ver', 'app_ver']"
                  label="App Version"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="appVer"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                  hint=""
                  persistent-hint
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeCoppa"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="coppaKey"
                  :items="['ads.coppa', 'coppa']"
                  label="COPPA"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="coppa"
                  disabled
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeIsLat"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="isLatKey"
                  :items="['ads.lmt', 'lmt']"
                  label="Limited Ad Tracking/DNT"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="isLat"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                  hint="0 or 1"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeLivestream"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="livestreamKey"
                  :items="['ads.livestream', 'livestream']"
                  label="LiveStream"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="livestream"
                  disabled
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeDeviceMake"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="deviceMakeKey"
                  :items="['ads.device_make', 'device_make']"
                  label="Device make"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="deviceMake"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                  hint="e.g., Samsung"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeDeviceModel"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="deviceModelKey"
                  :items="['ads.device_model', 'device_model']"
                  label="Device model"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="deviceModel"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                  hint="e.g., Tizen TV 2019"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeContentId"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="contentIdKey"
                  :items="['ads.content_id', 'content_id']"
                  label="Content ID"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="contentId"
                  disabled
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeContentLang"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="contentLangKey"
                  :items="['ads.content_language', 'content_language']"
                  label="Content Language"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="contentLang"
                  disabled
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
              <v-row align="center">
                <v-checkbox
                  v-model="includeVideoId"
                  hide-details
                  class="shrink ml-3 mr-2 mt-0"
                />
                <v-select
                  v-model="videoIdKey"
                  :items="['ads.video_id', 'video_id']"
                  label="Custom Video ID"
                  append-outer-icon="mdi-equal"
                  style="width: 203px;"
                  class="shrink mr-2 mt-0"
                  hide-details
                />
                <v-text-field
                  v-model="videoId"
                  style="min-width: 250px;"
                  class="shrink mr-2 mt-0"
                />
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            @click="updatePack()"
          >
            <v-icon left>
              mdi-content-save
            </v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </base-card>
    </v-col>
  </v-row>
</template>
<script>
  import { processDistributionPackage } from '@/store/converters'

  export default {
    metaInfo: {
      title: 'Edit Distribution Package',
    },
    data: () => ({
      distribPackage: {},
      patched: {
        name: '',
        mtPrefix: '',
        mtPrerollPrefix: '',
      },
      rules: {
        nameRules: [
          v => !!v || 'Name is required',
          v => (v.length >= 3 && v.length <= 255) || 'Name must be between 3 and 255 characters',
        ],
      },
      props: [
        {
          key: '',
          value: '',
          include: true,
          auto: true,
        },
      ],
      videoPlayerWidthKey: 'ads.w',
      videoPlayerWidth: 1920,
      includeVideoPlayerWidth: true,
      videoPlayerHeightKey: 'ads.h',
      videoPlayerHeight: 1080,
      includeVideoPlayerHeight: true,
      deviceIDKey: 'ads.did',
      deviceID: '',
      includeDeviceID: true,
      appBundleKey: 'ads.app_bundle',
      appBundle: 'smarttv',
      includeAppBundle: true,
      appNameKey: 'ads.app_name',
      appName: '',
      includeAppName: true,
      nameOfTVChannelKey: 'ads.channel_name',
      nameOfTVChannel: '(NP channel field)',
      includeNameOfTVChannel: true,
      genreKey: 'ads.content_genre',
      genre: '(NP Genre field)',
      includeGenre: true,
      ratingKey: 'ads.rating',
      rating: '(NP rating field)',
      includeRating: true,
      nameOfTheContentSeriesKey: 'ads.content_series',
      nameOfTheContentSeries: '(the name of the current TV show)',
      includeNameOfTheContentSeries: true,
      usPrivacyKey: 'ads.us_privacy',
      usPrivacy: '',
      includeUsPrivacy: true,
      appStoreURLKey: 'ads.app_store_url',
      appStoreURL: '',
      includeAppStoreURL: true,
      providerKey: 'ads.provider',
      provider: '(company name)',
      includeProvider: false,
      chainKey: 'ads.schain',
      chain: '1',
      includeChain: true,
      IABCategoryIDKey: 'ads.ic',
      IABCategoryID: '',
      includeIABCategoryID: true,
      URLFromWebsitesOnlyKey: 'ads.url',
      URLFromWebsitesOnly: '',
      includeURLFromWebsitesOnly: true,
      GDPRConsentKey: 'ads.gdpr_consent',
      GDPRConsent: '0',
      includeGDPRConsent: true,
      GDPRKey: 'ads.gdpr',
      GDPR: '1',
      includeGDPR: true,

      appPlatformKey: 'ads.app_platform',
      appPlatform: '',
      includeAppPlatform: false,

      appVerKey: 'ads.app_ver',
      appVer: '',
      includeAppVer: false,

      contentIdKey: 'ads.content_id',
      contentId: '(channel field)',
      includeContentId: true,

      contentLangKey: 'ads.content_language',
      contentLang: '(channel field)',
      includeContentLang: true,

      contentEpisodeKey: 'ads.content_episode',
      contentEpisode: '',
      includeContentEpisode: false,

      contentTitleKey: 'ads.content_title',
      contentTitle: '(the name of the current TV show)',
      includeContentTitle: false,

      contentSeasonKey: 'ads.content_season',
      contentSeason: '',
      includeContentSeason: false,

      contentCatKey: 'ads.content_cat',
      contentCat: '(channel field)',
      includeContentCat: true,

      videoIdKey: 'ads.video_id',
      videoId: '',
      includeVideoId: false,

      custom1Key: '',
      custom1: '',
      includeCustom1: false,
      custom2Key: '',
      custom2: '',
      includeCustom2: false,
      includeIP: true,
      IPKey: 'ads.ip',
      IP: '',
      includeUA: true,
      UAKey: 'ads.ua',
      UA: '',
      podMaxDurKey: 'ads.pod_max_dur',
      podMaxDur: '',
      includePodMaxDur: false,
      cbKey: 'ads.cb',
      cb: '',
      includeCb: false,
      coppaKey: 'ads.coppa',
      coppa: '(channel field)',
      includeCoppa: false,
      isLatKey: 'ads.lmt',
      isLat: '0',
      includeIsLat: false,
      livestreamKey: 'livestream',
      livestream: '1',
      includeLivestream: false,
      deviceMakeKey: 'ads.device_make',
      deviceMake: '',
      includeDeviceMake: false,
      deviceModelKey: 'ads.device_model',
      deviceModel: '',
      includeDeviceModel: false,
    }),
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      isPatchFormValid () {
        if (!(this.patched.name.length >= 3 && this.patched.name.length <= 255)) {
          return false
        }
        return true
      },
    },
    created () {
      this.getPackageInfo(this.$route.params.distribution_id)
    },
    methods: {
      propsToJson () {
        const props = []

        props.push({
          key: this.videoPlayerWidthKey,
          value: this.videoPlayerWidth,
          include: this.includeVideoPlayerWidth,
          auto: false,
        })

        props.push({
          key: this.videoPlayerHeightKey,
          value: this.videoPlayerHeight,
          include: this.includeVideoPlayerHeight,
          auto: false,
        })

        props.push({
          key: this.deviceIDKey,
          value: this.deviceID,
          include: this.includeDeviceID,
          auto: false,
        })

        props.push({
          key: this.appBundleKey,
          value: this.appBundle,
          include: this.includeAppBundle,
          auto: false,
        })

        props.push({
          key: this.appPlatformKey,
          value: this.appPlatform,
          include: this.includeAppPlatform,
          auto: false,
        })

        props.push({
          key: this.appVerKey,
          value: this.appVer,
          include: this.includeAppVer,
          auto: false,
        })

        props.push({
          key: this.contentIdKey,
          value: this.contentId,
          include: this.includeContentId,
          auto: true,
        })

        props.push({
          key: this.contentLangKey,
          value: this.contentLang,
          include: this.includeContentLang,
          auto: true,
        })

        props.push({
          key: this.contentEpisodeKey,
          value: this.contentEpisode,
          include: this.includeContentEpisode,
          auto: false,
        })

        props.push({
          key: this.contentTitleKey,
          value: '(the name of the current TV show)',
          include: this.includeContentTitle,
          auto: true,
        })

        props.push({
          key: this.contentSeasonKey,
          value: this.contentSeason,
          include: this.includeContentSeason,
          auto: false,
        })

        props.push({
          key: this.appNameKey,
          value: this.appName,
          include: this.includeAppName,
          auto: false,
        })

        props.push({
          key: this.appStoreURLKey,
          value: this.appStoreURL,
          include: this.includeAppStoreURL,
          auto: false,
        })

        props.push({
          key: this.providerKey,
          value: this.provider,
          include: this.includeProvider,
          auto: true,
        })

        props.push({
          key: this.chainKey,
          value: this.chain,
          include: this.includeChain,
          auto: false,
        })

        props.push({
          key: this.URLFromWebsitesOnlyKey,
          value: this.URLFromWebsitesOnly,
          include: this.includeURLFromWebsitesOnly,
          auto: false,
        })

        props.push({
          key: this.GDPRConsentKey,
          value: this.GDPRConsent,
          include: this.includeGDPRConsent,
          auto: false,
        })

        props.push({
          key: this.GDPRKey,
          value: this.GDPR,
          include: this.includeGDPR,
          auto: false,
        })

        props.push({
          key: this.IPKey,
          value: this.IP,
          include: this.includeIP,
          auto: false,
        })

        props.push({
          key: this.UAKey,
          value: this.UA,
          include: this.includeUA,
          auto: false,
        })
        //
        props.push({
          key: this.nameOfTVChannelKey,
          value: this.nameOfTVChannel,
          include: this.includeNameOfTVChannel,
          auto: true,
        })

        props.push({
          key: this.genreKey,
          value: this.genre,
          include: this.includeGenre,
          auto: true,
        })

        props.push({
          key: this.ratingKey,
          value: this.rating,
          include: this.includeRating,
          auto: true,
        })

        props.push({
          key: this.nameOfTheContentSeriesKey,
          value: this.nameOfTheContentSeries,
          include: this.includeNameOfTheContentSeries,
          auto: true,
        })

        props.push({
          key: this.usPrivacyKey,
          value: this.usPrivacy,
          include: this.includeUsPrivacy,
          auto: false,
        })

        props.push({
          key: this.IABCategoryIDKey,
          value: this.IABCategoryID,
          include: this.includeIABCategoryID,
          auto: false,
        })

        props.push({
          key: this.contentCatKey,
          value: this.contentCat,
          include: this.includeContentCat,
          auto: true,
        })

        props.push({
          key: this.videoIdKey,
          value: this.videoId,
          include: this.includeVideoId,
          auto: false,
        })

        props.push({
          key: this.podMaxDurKey,
          value: this.podMaxDur,
          include: this.includePodMaxDur,
          auto: true,
        })

        props.push({
          key: this.cbKey,
          value: this.cb,
          include: this.includeCb,
          auto: true,
        })

        props.push({
          key: this.coppaKey,
          value: this.coppa,
          include: this.includeCoppa,
          auto: true,
        })

        props.push({
          key: this.isLatKey,
          value: this.isLat,
          include: this.includeIsLat,
          auto: false,
        })

        props.push({
          key: this.livestreamKey,
          value: this.livestream,
          include: this.includeLivestream,
          auto: false,
        })

        props.push({
          key: this.deviceMakeKey,
          value: this.deviceMake,
          include: this.includeDeviceMake,
          auto: false,
        })

        props.push({
          key: this.deviceModelKey,
          value: this.deviceModel,
          include: this.includeDeviceModel,
          auto: false,
        })

        //
        props.push({
          key: this.custom1Key,
          value: this.custom1,
          include: this.includeCustom1,
          auto: false,
          custom: '1',
        })
        props.push({
          key: this.custom2Key,
          value: this.custom2,
          include: this.includeCustom2,
          auto: false,
          custom: '2',
        })
        for (let i = 0; i < props.length; i += 1) {
          props[i].key = String(props[i].key)
          props[i].value = String(props[i].value)
        }
        return props
      },
      changeFormat () {
        if (this.patched.format === 'broadpeak') {
          this.videoPlayerWidthKey = 'width'
          this.videoPlayerHeightKey = 'height'
          this.deviceIDKey = 'did'
          this.appBundleKey = 'app_bundle'
          this.appPlatformKey = 'app_platform'
          this.appNameKey = 'app_name'
          this.nameOfTVChannelKey = 'channel_name'
          this.genreKey = 'content_genre'
          this.ratingKey = 'rating'
          this.nameOfTheContentSeriesKey = 'content_series'
          this.usPrivacyKey = 'us_privacy'
          this.appStoreURLKey = 'app_store_url'
          this.providerKey = 'provider'
          this.chainKey = 'schain'
          this.IABCategoryIDKey = 'ic'
          this.URLFromWebsitesOnlyKey = 'url'
          this.GDPRConsentKey = 'gdpr_consent'
          this.GDPRKey = 'gdpr'
          this.IPKey = 'ip'
          this.UAKey = 'ua'
          this.podMaxDurKey = 'pod_max_dur'
          this.cbKey = 'cb'
          this.coppaKey = 'coppa'
          this.appVerKey = 'app_ver'
          this.isLatKey = 'lmt'
          this.livestreamKey = 'livestream'
          this.deviceMakeKey = 'device_make'
          this.deviceModelKey = 'device_model'
          this.contentIdKey = 'content_id'
          this.contentLangKey = 'content_language'
          this.contentEpisodeKey = 'content_episode'
          this.contentTitleKey = 'content_title'
          this.contentSeasonKey = 'content_season'
          this.contentCatKey = 'content_cat'
          this.videoIdKey = 'video_id'
        } else {
          this.videoPlayerWidthKey = 'ads.w'
          this.videoPlayerHeightKey = 'ads.h'
          this.deviceIDKey = 'ads.did'
          this.appBundleKey = 'ads.app_bundle'
          this.appPlatformKey = 'ads.app_platform'
          this.appNameKey = 'ads.app_name'
          this.nameOfTVChannelKey = 'ads.channel_name'
          this.genreKey = 'ads.content_genre'
          this.ratingKey = 'ads.rating'
          this.nameOfTheContentSeriesKey = 'ads.content_series'
          this.usPrivacyKey = 'ads.us_privacy'
          this.appStoreURLKey = 'ads.app_store_url'
          this.providerKey = 'ads.provider'
          this.chainKey = 'ads.schain'
          this.IABCategoryIDKey = 'ads.ic'
          this.URLFromWebsitesOnlyKey = 'ads.url'
          this.GDPRConsentKey = 'ads.gdpr_consent'
          this.GDPRKey = 'ads.gdpr'
          this.IPKey = 'ads.ip'
          this.UAKey = 'ads.ua'
          this.podMaxDurKey = 'ads.pod_max_dur'
          this.cbKey = 'ads.cb'
          this.coppaKey = 'ads.coppa'
          this.appVerKey = 'ads.app_ver'
          this.isLatKey = 'ads.lmt'
          this.livestreamKey = 'ads.livestream'
          this.deviceMakeKey = 'ads.device_make'
          this.deviceModelKey = 'ads.device_model'
          this.contentIdKey = 'ads.content_id'
          this.contentLangKey = 'ads.content_language'
          this.contentEpisodeKey = 'ads.content_episode'
          this.contentTitleKey = 'ads.content_title'
          this.contentSeasonKey = 'ads.content_season'
          this.contentCatKey = 'ads.content_cat'
          this.videoIdKey = 'ads.video_id'
        }
      },
      propsToForm (props) {
        for (let i = 0; i < props.length; i += 1) {
          const p = props[i]

          switch (p.key) {
            case 'ads.w':
              this.videoPlayerWidthKey = 'ads.w'
              this.videoPlayerWidth = p.value
              this.includeVideoPlayerWidth = p.include
              break

            case 'width':
              this.videoPlayerWidthKey = 'width'
              this.videoPlayerWidth = p.value
              this.includeVideoPlayerWidth = p.include
              break

            case 'ads.h':
              this.videoPlayerHeightKey = 'ads.h'
              this.videoPlayerHeight = p.value
              this.includeVideoPlayerHeight = p.include
              break

            case 'height':
              this.videoPlayerHeightKey = 'height'
              this.videoPlayerHeight = p.value
              this.includeVideoPlayerHeight = p.include
              break

            case 'ads.did':
              this.deviceIDKey = 'ads.did'
              this.deviceID = p.value
              this.includeDeviceID = p.include
              break

            case 'did':
              this.deviceIDKey = 'did'
              this.deviceID = p.value
              this.includeDeviceID = p.include
              break

            case 'ads.app_bundle':
              this.appBundleKey = 'ads.app_bundle'
              this.appBundle = p.value
              this.includeAppBundle = p.include
              break

            case 'app_bundle':
              this.appBundleKey = 'app_bundle'
              this.appBundle = p.value
              this.includeAppBundle = p.include
              break

            case 'ads.app_platform':
              this.appPlatformKey = 'ads.app_platform'
              this.appPlatform = p.value
              this.includeAppPlatform = p.include
              break

            case 'app_platform':
              this.appPlatformKey = 'app_platform'
              this.appPlatform = p.value
              this.includeAppPlatform = p.include
              break

            case 'ads.app_ver':
              this.appVerKey = 'ads.app_ver'
              this.appVer = p.value
              this.includeAppVer = p.include
              break

            case 'app_ver':
              this.appVerKey = 'app_ver'
              this.appVer = p.value
              this.includeAppVer = p.include
              break

            case 'ads.content_episode':
              this.contentEpisodeKey = 'ads.content_episode'
              this.contentEpisode = p.value
              this.includeContentEpisode = p.include
              break

            case 'content_episode':
              this.contentEpisodeKey = 'content_episode'
              this.contentEpisode = p.value
              this.includeContentEpisode = p.include
              break

            case 'ads.content_title':
              this.contentTitleKey = 'ads.content_title'
              //this.contentTitle = p.value
              this.includeContentTitle = p.include
              break

            case 'content_title':
              this.contentTitleKey = 'content_title'
              //this.contentTitle = p.value
              this.includeContentTitle = p.include
              break

            case 'ads.content_season':
              this.contentSeasonKey = 'ads.content_season'
              this.contentSeason = p.value
              this.includeContentSeason = p.include
              break

            case 'content_season':
              this.contentSeasonKey = 'content_season'
              this.contentSeason = p.value
              this.includeContentSeason = p.include
              break

            case 'ads.app_name':
              this.appNameKey = 'ads.app_name'
              this.appName = p.value
              this.includeAppName = p.include
              break

            case 'app_name':
              this.appNameKey = 'app_name'
              this.appName = p.value
              this.includeAppName = p.include
              break

            case 'ads.channel_name':
              this.nameOfTVChannelKey = 'ads.channel_name'
              this.includeNameOfTVChannel = p.include
              break

            case 'channel_name':
              this.nameOfTVChannelKey = 'channel_name'
              this.includeNameOfTVChannel = p.include
              break

            case 'ads.content_genre':
              this.genreKey = 'ads.content_genre'
              this.includeGenre = p.include
              break

            case 'content_genre':
              this.genreKey = 'content_genre'
              this.includeGenre = p.include
              break

            case 'ads.rating':
              this.ratingKey = 'ads.rating'
              this.includeRating = p.include
              break

            case 'rating':
              this.ratingKey = 'rating'
              this.includeRating = p.include
              break

            case 'ads.content_series':
              this.nameOfTheContentSeriesKey = 'ads.content_series'
              this.includeNameOfTheContentSeries = p.include
              break

            case 'content_series':
              this.nameOfTheContentSeriesKey = 'content_series'
              this.includeNameOfTheContentSeries = p.include
              break

            case 'ads.us_privacy':
              this.usPrivacyKey = 'ads.us_privacy'
              this.includeUsPrivacy = p.include
              this.usPrivacy = p.value
              break

            case 'us_privacy':
              this.usPrivacyKey = 'us_privacy'
              this.includeUsPrivacy = p.include
              this.usPrivacy = p.value
              break

            case 'ads.app_store_url':
              this.appStoreURLKey = 'ads.app_store_url'
              this.appStoreURL = p.value
              this.includeAppStoreURL = p.include
              break

            case 'app_store_url':
              this.appStoreURLKey = 'app_store_url'
              this.appStoreURL = p.value
              this.includeAppStoreURL = p.include
              break

            case 'ads.provider':
              this.providerKey = 'ads.provider'
              this.includeProvider = p.include
              break

            case 'provider':
              this.providerKey = 'provider'
              this.includeProvider = p.include
              break

            case 'ads.schain':
              this.chainKey = 'ads.schain'
              this.chain = p.value
              this.includeChain = p.include
              break

            case 'schain':
              this.chainKey = 'schain'
              this.chain = p.value
              this.includeChain = p.include
              break

            case 'ads.ic':
              this.IABCategoryIDKey = 'ads.ic'
              if (p.value === '(channel properties)') p.value = ''
              this.IABCategoryID = p.value
              this.includeIABCategoryID = p.include
              break

            case 'ic':
              this.IABCategoryIDKey = 'ic'
              if (p.value === '(channel properties)') p.value = ''
              this.IABCategoryID = p.value
              this.includeIABCategoryID = p.include
              break

            case 'ads.content_cat':
              this.contentCatKey = 'ads.content_cat'
              this.includeContentCat = p.include
              break

            case 'content_cat':
              this.contentCatKey = 'content_cat'
              this.includeContentCat = p.include
              break

            case 'ads.url':
              this.URLFromWebsitesOnlyKey = 'ads.url'
              this.URLFromWebsitesOnly = p.value
              this.includeURLFromWebsitesOnly = p.include
              break

            case 'url':
              this.URLFromWebsitesOnlyKey = 'url'
              this.URLFromWebsitesOnly = p.value
              this.includeURLFromWebsitesOnly = p.include
              break

            case 'ads.gdpr_consent':
              this.GDPRConsentKey = 'ads.gdpr_consent'
              this.GDPRConsent = p.value
              this.includeGDPRConsent = p.include
              break

            case 'gdpr_consent':
              this.GDPRConsentKey = 'gdpr_consent'
              this.GDPRConsent = p.value
              this.includeGDPRConsent = p.include
              break

            case 'ads.gdpr':
              this.GDPRKey = 'ads.gdpr'
              this.GDPR = p.value
              this.includeGDPR = p.include
              break

            case 'gdpr':
              this.GDPRKey = 'gdpr'
              this.GDPR = p.value
              this.includeGDPR = p.include
              break

            case 'ads.ip':
              this.IPKey = 'ads.ip'
              this.IP = p.value
              this.includeIP = p.include
              break

            case 'ip':
              this.IPKey = 'ip'
              this.IP = p.value
              this.includeIP = p.include
              break

            case 'ads.ua':
              this.UAKey = 'ads.ua'
              this.UA = p.value
              this.includeUA = p.include
              break

            case 'ua':
              this.UAKey = 'ua'
              this.UA = p.value
              this.includeUA = p.include
              break

            case 'ads.pod_max_dur':
              this.podMaxDurKey = 'ads.pod_max_dur'
              this.podMaxDur = p.value
              this.includePodMaxDur = p.include
              break

            case 'pod_max_dur':
              this.podMaxDurKey = 'pod_max_dur'
              this.podMaxDur = p.value
              this.includePodMaxDur = p.include
              break

            case 'ads.cb':
              this.cbKey = 'ads.cb'
              this.cb = p.value
              this.includeCb = p.include
              break

            case 'cb':
              this.cbKey = 'cb'
              this.cb = p.value
              this.includeCb = p.include
              break

            case 'coppa':
              this.coppaKey = 'coppa'
              this.includeCoppa = p.include
              break

            case 'ads.coppa':
              this.coppaKey = 'ads.coppa'
              this.includeCoppa = p.include
              break

            case 'ads.lmt':
              this.isLatKey = 'ads.lmt'
              this.isLat = p.value
              this.includeIsLat = p.include
              break

            case 'lmt':
              this.isLatKey = 'lmt'
              this.isLat = p.value
              this.includeIsLat = p.include
              break

            case 'ads.livestream':
              this.livestreamKey = 'ads.livestream'
              this.includeLivestream = p.include
              break

            case 'livestream':
              this.livestreamKey = 'livestream'
              this.includeLivestream = p.include
              break

            case 'ads.device_make':
              this.deviceMakeKey = 'ads.device_make'
              this.deviceMake = p.value
              this.includeDeviceMake = p.include
              break

            case 'device_make':
              this.deviceMakeKey = 'device_make'
              this.deviceMake = p.value
              this.includeDeviceMake = p.include
              break

            case 'ads.device_model':
              this.deviceModelKey = 'ads.device_model'
              this.deviceModel = p.value
              this.includeDeviceModel = p.include
              break

            case 'device_model':
              this.deviceModelKey = 'device_model'
              this.deviceModel = p.value
              this.includeDeviceModel = p.include
              break

            case 'ads.content_id':
              this.contentIdKey = 'ads.content_id'
              this.includeContentId = p.include
              break

            case 'content_id':
              this.contentIdKey = 'content_id'
              this.includeContentId = p.include
              break

            case 'ads.content_language':
              this.contentLangKey = 'ads.content_language'
              this.includeContentLang = p.include
              break

            case 'content_language':
              this.contentLangKey = 'content_language'
              this.includeContentLang = p.include
              break

            case 'ads.video_id':
              this.videoIdKey = 'ads.video_id'
              this.videoId = p.value
              this.includeVideoId = p.include
              break

            case 'video_id':
              this.videoIdKey = 'video_id'
              this.videoId = p.value
              this.includeVideoId = p.include
              break
          }
          if (p.custom === '1') {
            this.custom1Key = p.key
            this.custom1 = p.value
            this.includeCustom1 = p.include
          }

          if (p.custom === '2') {
            this.custom2Key = p.key
            this.custom2 = p.value
            this.includeCustom2 = p.include
          }
        }
      },
      getPackageInfo (id) {
        this.$store.commit('setPageLoader')

        const args = {
          'id[eq]': id,
        }
        const packReq = this.$store.dispatch('distributionPackages', args)

        return Promise.all([packReq])
          .then((res) => {
            const packages = res[0] || []
            if (!packages.length) {
              this.$router.push({ name: 'ChannelsPage' })
            }
            this.distribPackage = processDistributionPackage(packages[0])

            this.patched.name = this.distribPackage.name
            this.patched.mtPrefix = this.distribPackage.mtPrefix
            this.patched.mtPrerollPrefix = this.distribPackage.mtPrerollPrefix
            this.patched.format = this.distribPackage.format
            this.propsToForm(this.distribPackage.props)
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
            this.$router.push({ name: 'Distributions' })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      updatePack () {
        this.$store.commit('setPageLoader')

        const pack = {
          id: this.distribPackage.id,
          name: this.patched.name,
          mt_prefix: this.patched.mtPrefix,
          mt_preroll_prefix: this.patched.mtPrerollPrefix,
          props: this.propsToJson(),
          format: this.patched.format,
        }

        this.$store.dispatch('patchDistributionPackage', pack)
          .then(() => {
            this.$store.commit('showSnackbar', {
              text: 'The package has been successfully updated',
              timeout: 6000,
              color: 'success',
            })
            this.distribPackage.name = this.patched.name
            this.distribPackage.mtPrefix = this.patched.mtPrefix
            this.distribPackage.mtPrerollPrefix = this.patched.mtPrerollPrefix
            this.distribPackage.format = this.patched.format
            this.$router.push({
              name: 'Distribution',
              params: {
                distribution_id: this.distribPackage.id,
              },
            })
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => {
            this.$store.commit('resolvePageLoader')
          })
      },
    },
  }
</script>

<style>
@media (min-width: 1200px) {
  .container {
    max-width: 1320px !important;
  }
}
</style>
